module.exports = __webpack_public_path__ + "img/Flag_of_Iran.7e6ba74d.svg";